var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
/**
 * Checks if the salePoint has any fields
 * found in school and not regular sale points
 * */
var isSchool = function (salePoint) { return !!salePoint.department || !!salePoint.shortName; };
/**
 * Accepts the standard format on salePoints
 * given from the server directly, and presents
 * it as a select field.
 * */
var SalePointSelectField = function (props) {
    var currentValue = props.currentValue, onChange = props.onChange, onBlur = props.onBlur, name = props.name, salePoints = props.salePoints, otherProps = __rest(props, ["currentValue", "onChange", "onBlur", "name", "salePoints"]);
    /**
     * Used to identify which of the items is a school
     * */
    var mySchoolValue = 'my_school';
    return React.createElement("select", __assign({ name: name, id: name, value: currentValue, onChange: onChange, onBlur: onBlur }, otherProps),
        React.createElement("option", { value: "", disabled: true }, "Velg utsalgssted"),
        salePoints.map(function (salePoint, key) { return React.createElement("option", { key: "salepoint-" + key, value: (!isSchool(salePoint)) ? salePoint.id : mySchoolValue }, (!isSchool(salePoint)) ? salePoint.salePoint : salePoint.shortName + " " + salePoint.department); }));
};
export default SalePointSelectField;
